module.exports = __webpack_public_path__ + "img/folder.3388f386.svg";